(function () {
    angular.module('app')
        .controller('GridCarouselController', GridCarouselController);

    GridCarouselController.$inject = ['$scope', '$element', '$window', '$attrs'];
    function GridCarouselController($scope, $element, $window, $attrs) {
        var ctrl = this;

        
        function getClientPos(data, index) {
            var start = Math.floor(index / data.slideData.length);
            var currentIndex = (index + Math.abs(data.slideData.length * start)) % data.slideData.length;
            return start * data.totalWidth + data.offsets[currentIndex];
        }

        ctrl.slideAnimation = function (offset, index, data) {
            var element = angular.element(data.elements[index]);
            var images = element.find('img');
            var width = data.slideWidth;
            if (!width) {
                images.css('display', 'none');
                var width = angular.element(data.elements[index]).outerWidth();
                images.css('display', '');
                if (!width && data.slideData[index].image) {
                    width = data.slideData[index].image.width;
                }
            }
            var rounds = -Math.floor((getClientPos(data, index) + offset + (data.slideData.length > 1 ? width : 0) + data.spacing) / data.totalWidth);
            var roundLength = data.slideData.length;
            var renderIndex = index + (rounds * roundLength);
            return {
                x: getClientPos(data, renderIndex) + offset,
                y: 0,
                width: width
            };
        }

        ctrl.slideAnimationPrep = function (data) {
            if (data.slideData) {
                var totalWidth = 0;
                var offsets = [];
                var breakpoints = [];
                var elements = [];
                var maxHeight = 0;
                if (data.slideWidth) {
                    data.slideElements.width(data.slideWidth);
                }
                for (var i = 0; i < data.slideData.length; i++) {
                    offsets.push(totalWidth);
                    var element = angular.element(data.slideElements[i]).find('>div,>a');
                    var images = element.find('img');
                    var width = data.slideWidth;
                    elements.push(element);
                    var imagesLoaded = images.hasClass('loaded');
                    if (!imagesLoaded) {
                        images.css('display', 'none');
                    }
                    var height = element.outerHeight();
                    if (!imagesLoaded) {
                        images.css('display', '');
                    }
                    var margin = data.spacing;
                    if (images.length) {
                        var item = data.slideData[i];
                        if (data.slideWidth) {
                            if (!imagesLoaded) {
                                var source = images.attr('image-source');
                                var widthResult = /width\=(\d+)/.exec(source);
                                var imageWidth = widthResult[1] ? parseInt(widthResult[1]) : item.image.width;
                                var heightResult = /height\=(\d+)/.exec(source);
                                var imageHeight = heightResult[1] ? parseInt(heightResult[1]) : item.image.height;
                                console.log(heightResult[1], item.image.height);
                                var scale = imageWidth / data.slideWidth;
                                if (scale > 1) {
                                    imageHeight /= scale;
                                }
                                height += imageHeight;
                            }
                        }
                        else {
                            width = item.image ? item.image.width : 0;
                            if (!item.image) {
                                margin = 0;
                            }
                            else {
                                var scale = item.image.height / images.height();
                                item.image.width /= scale;
                                item.image.height /= scale;
                                width = item.image.width;
                                
                            }
                            if (!height) {
                                height = images.height();
                            }
                        }
                    }
                    
                    if (parseInt($attrs.imageHeight) > 0) {
                        height = parseInt($attrs.imageHeight);
                    }

                    maxHeight = Math.max(height, maxHeight);
                    breakpoints.push(totalWidth + margin + (width / 2));
                    totalWidth += width + margin;
                }
                data.elements = elements;
                data.totalWidth = totalWidth;
                data.offsets = offsets;
                data.breakpoints = breakpoints;
                
                data.carousel.find('.slides').height(maxHeight);
            }
            return data;
        }

        ctrl.slideSnap = function (offset, data) {
            var pos = 0;
            var shift = Math.abs(offset % data.totalWidth);
            if (offset > 0) {
                shift = data.totalWidth - shift;
            }
            for (var i = 0; i < data.offsets.length; i++) {
                if (shift <= data.breakpoints[i]) {
                    pos = i;
                    break;
                }
            }
            var index = -(Math.ceil(offset / data.totalWidth) * data.slideData.length - pos);
            return {
                index: index,
                position: -getClientPos(data, index)
            };
        }
    }
})();